import { globalActions, userActions } from '@modules';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

export const clickMenuItem: TMiddleware = store => next => action => {
  const { user, global } = store.getState();
  const { isCountryModal } = user;
  const { zhModalType } = global;

  if (checkActionsType(action, [globalActions.clickMenuItem])) {
    if (zhModalType) store.dispatch(globalActions.closeZHModal());
    if (isCountryModal) store.dispatch(userActions.setIsCountry(false));
  }
  return next(action);
};

export default clickMenuItem;
